import { createContext } from 'react';

import { FieldFilter } from '@atom/types/work';
import {
  WorkOrderTemplateFolder,
  WorkTemplate,
} from '@atom/types/workTemplate';

export type AdditionalFieldFilters = {
  [fieldId: string]: FieldFilter;
};

export type TasksAdditionalFieldFilters = {
  [taskId: string]: AdditionalFieldFilters;
};

export type FilterForm = {
  workDueDateStart?: number;
  workDueDateEnd?: number;
  workDueDateSelectValue?: string;
  workCompletionDateStart?: number;
  workCompletionDateEnd?: number;
  workCompletionDateSelectValue?: string;
  workAppliedDateStart?: number;
  workAppliedDateEnd?: number;
  workAppliedDateSelectValue?: string;
  selectStatuses: number[];
  selectPriorities: number[];
  workTemplateFolders: WorkOrderTemplateFolder[];
  hasWorkTemplate?: boolean;
  workTemplates: WorkTemplate[];
  workTemplateFields: AdditionalFieldFilters;
  taskDueDateStart?: number;
  taskDueDateEnd?: number;
  taskDueDateSelectValue?: string;
  taskStartDateStart?: number;
  taskStartDateEnd?: number;
  taskStartDateSelectValue?: string;
  taskCompletionDateStart?: number;
  taskCompletionDateEnd?: number;
  taskCompletionDateSelectValue?: string;
  taskDurationStart?: number;
  taskDurationEnd?: number;
  taskCustomCommonFields: AdditionalFieldFilters;
  workTemplateTaskFields: TasksAdditionalFieldFilters;
  teamAssignedToGroupIds: string[];
  teamAssignedToUserIds: string[];
  teamCompletedByIds: string[];
  teamCreatedByIds: string[];
};

export const FILTER_DEFAULTS: FilterForm = {
  workDueDateStart: null,
  workDueDateEnd: null,
  workDueDateSelectValue: null,
  workCompletionDateStart: null,
  workCompletionDateEnd: null,
  workCompletionDateSelectValue: null,
  workAppliedDateStart: null,
  workAppliedDateEnd: null,
  workAppliedDateSelectValue: null,
  selectStatuses: [],
  selectPriorities: [],
  workTemplateFolders: [],
  hasWorkTemplate: null,
  workTemplates: [],
  workTemplateFields: {},
  taskDueDateStart: null,
  taskDueDateEnd: null,
  taskDueDateSelectValue: null,
  taskStartDateStart: null,
  taskStartDateEnd: null,
  taskStartDateSelectValue: null,
  taskCompletionDateStart: null,
  taskCompletionDateEnd: null,
  taskCompletionDateSelectValue: null,
  taskDurationStart: null,
  taskDurationEnd: null,
  taskCustomCommonFields: {},
  workTemplateTaskFields: {},
  teamAssignedToGroupIds: [],
  teamAssignedToUserIds: [],
  teamCompletedByIds: [],
  teamCreatedByIds: [],
};

export type WorkOrdersFiltersContextValue = {
  schemaId: string;
  areFiltersDisabled: boolean;
  filterForm: FilterForm;
  workOrderTemplate: WorkTemplate | null;
  // value may instead be an updater of the field's current value, like
  // setState - a plain value loses writes when two land in one React batch
  updateFilterForm: (field: keyof FilterForm, value: any) => void;
};

export const initialState: WorkOrdersFiltersContextValue = {
  schemaId: '',
  areFiltersDisabled: false,
  filterForm: FILTER_DEFAULTS,
  workOrderTemplate: null,
  updateFilterForm: () => {},
};

const WorkOrdersFiltersContext =
  createContext<WorkOrdersFiltersContextValue>(initialState);

export default WorkOrdersFiltersContext;
